import { ConnectedRouter } from 'connected-react-router';
import React               from 'react';
import * as ReactDOM       from 'react-dom';
import { Provider }        from 'react-redux';
import { renderRoutes }    from 'react-router-config';
import { HelmetProvider }  from  'react-helmet-async';

import './client/services/AARPAnalyticsService';
import './client/services/AuthService';
import './polyfills';
import { routes }    from './routes';

import Header        from './client/organisms/Header/Header';
import { RouterWrapper } from './client/atoms/RouterWrapper';

import { UserAuthStatus }             from './client/models/UserAuthStatus';
import AARPAuthService                from './client/services/AARPAuthService';
import { Analytics }                  from './client/services/Analytics/Analytics';
import AuthService                    from './client/services/AuthService';
import createStore                    from './client/store/index';
import { setUser, setUserAuthStatus } from './client/store/reducers';
import { isServer }                   from './utils';
import { ADO_BUILD_VERSION }          from './version';
import { LocalStorageService }        from './client/services/LocalStorage';
import { FingerprintService } from './client/services/Analytics/FingerprintJS/FingerprintService';
import { WebVitals } from './client/models/WebVitals';
import { onCLS, onLCP, onINP, onFCP, onTTFB } from 'web-vitals';

const { store, history } = createStore();

if (!isServer) {
    (window as any).STORE = store;
    LocalStorageService.setItem('build_version', ADO_BUILD_VERSION);
}

(Provider as any).displayName = 'Provider';
Analytics.init();
const historyNavigation = Analytics.historyNavigationCalculate();
Analytics.trackPageView(historyNavigation);
FingerprintService.init();

export class App extends React.Component {
    static displayName = 'App';

    trackWebVitals() {
        const lsKey = 'skipcwv';
        const lsValue = LocalStorageService.getItem(lsKey);
        let skipCWVTracking = false;

        if (lsValue === null) {
            skipCWVTracking = !(Math.random() < 30 / 100); // 30% of users should send the event
            LocalStorageService.setItem(lsKey, skipCWVTracking);
        } else {
            skipCWVTracking = lsValue === 'true';
        }

        if (skipCWVTracking) {
            return;
        }

        onLCP(metric => addToMetrics({...metric, name: metric.name}));

        onCLS(metric => {
            Analytics.trackEvent(Analytics.general.webVitals({[metric.name]: JSON.stringify({value: metric.value, name: metric.name})}));
        });

        onINP(metric => {
            Analytics.trackEvent(Analytics.general.webVitals({[metric.name]: JSON.stringify({value: metric.value, name: metric.name})}));
        });

        onFCP(metric => addToMetrics({...metric, name: metric.name}));

        onTTFB(metric => addToMetrics({...metric, name: metric.name}));

        let allMetrics: WebVitals = {};

        function addToMetrics(metric) {
            allMetrics[metric.name] = {
                value: metric.value
            };

            // collect on page load: FCP, TTFB, LCP
            if (allMetrics['LCP'] && allMetrics['FCP'] && allMetrics['TTFB']) {
                sendToAnalytics(allMetrics);
            }
        }

        function sendToAnalytics(metrics: WebVitals) {

            const transformedMetrics: Record<string, string> = {};

            for (const [key, value] of Object.entries(metrics)) {
                transformedMetrics[key] = JSON.stringify(value); // Serialize each value
            }

            Analytics.trackEvent(Analytics.general.webVitals(transformedMetrics));
            allMetrics = {};
        }

    }
        componentDidMount() {
        store.dispatch(setUserAuthStatus(UserAuthStatus.PENDING));
        AARPAuthService.init();
        AuthService.handleToken();
        this.trackWebVitals();

        AuthService.authUser()
            .then(user => {
                store.dispatch(setUser(user));
                store.dispatch(setUserAuthStatus(UserAuthStatus.USER_AUTHORIZED));
            })
            .catch(() => {
                store.dispatch(setUserAuthStatus(UserAuthStatus.USER_NOT_AUTHORIZED));
            });
    }

    render() {
        return (
            <HelmetProvider>
                <Provider store = {store}>
                    <ConnectedRouter history = {history}>
                        <RouterWrapper>
                            <div>
                                <img
                                    src="//d.adroll.com/ipixel/2ALHSDOMQFGDTMK6VWH3W3/IOD67BELXBAVZJIVG4WA6S"
                                    width="1"
                                    height="1"
                                    aria-hidden = "true"
                                />
                                <img
                                    src="https://amplifypixel.outbrain.com/pixel?mid=00b0d91fea41c4b1db6f9822c0399f54d7"
                                    width="1"
                                    height="1"
                                    aria-hidden = "true"
                                />
                                <Header />
                                {renderRoutes(routes)}
                            </div>
                        </RouterWrapper>
                    </ConnectedRouter>
                </Provider>
            </HelmetProvider>
        );
    }
}

const root = document.getElementById('root');
root.innerHTML = '';
ReactDOM.render(<App />, root);

export default App;
